import { render, staticRenderFns } from "./AdvanceGraduation.vue?vue&type=template&id=abff58a6&scoped=true"
import script from "./AdvanceGraduation.vue?vue&type=script&lang=js"
export * from "./AdvanceGraduation.vue?vue&type=script&lang=js"
import style0 from "./AdvanceGraduation.vue?vue&type=style&index=0&id=abff58a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abff58a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
